import request from '../../plugins/request'

// 获取章节内容集合
export function getAuthorChapterContentList (data) {
  return request({
    url: '/api/AuthorChapterContent/GetAuthorChapterContentList',
    method: 'post',
    data
  })
}

// 添加章节内容
export function addAuthorChapterContent (data) {
  return request({
    url: '/api/AuthorChapterContent/AddAuthorChapterContent',
    method: 'post',
    data
  })
}

export function updateAuthorChapterContentInfo (data) {
  return request({
    url: '/api/AuthorChapterContent/UpdateAuthorChapterContentInfo',
    method: 'post',
    data
  })
}

export function updateAuthorChapterContentList (data) {
  return request({
    url: '/api/AuthorChapterContent/UpdateAuthorChapterContentList',
    method: 'post',
    data
  })
}

export function updateSomeDataContentList (data) {
  return request({
    url: '/api/AuthorChapterContent/UpdateSomeContentList',
    method: 'post',
    data
  })
}

export function addPublishChapterReport (data) {
  return request({
    url: '/api/AuthorChapterContent/AddChapterPublishReport',
    method: 'post',
    data
  })
}

// 发布文件
export function publish (data) {
  return request({
    url: '/api/Book/Publish',
    method: 'post',
    data,
    baseURL: process.env.VUE_APP_NOVEL_API
  })
}

// 作品信息
export function getAuthorWorksInfo (data) {
  return request({
    url: '/api/AuthorWorks/GetAuthorWorksInfo',
    method: 'post',
    data
  })
}

// 作品信息
export function getLastPublishChapter (data) {
  return request({
    url: '/api/AuthorWorks/GetLastPublishChapterById',
    method: 'post',
    data
  })
}

// 更新章节内容集合状态
export function updateAuthorChapterListStatus (data) {
  return request({
    url: '/api/AuthorChapterContent/UpdateAuthorChapterListStatus',
    method: 'post',
    data
  })
}

// 更新章节内容集合定时任务状态
export function updateAuthorChapterListSechdule (data) {
  return request({
    url: '/api/AuthorChapterContent/UpdateAuthorChapterListSechdule',
    method: 'post',
    data
  })
}

// 记录发布章节和书籍信息
export function AddPublishChapter (data) {
  return request({
    url: '/api/AuthorChapterContent/AddChapterPublishReport',
    method: 'post',
    data
  })
}

// 定时发布
export function postArticle (data) {
  return request({
    url: '/api/QuartzApi/PostArticle',
    method: 'post',
    data//,
    // baseURL: process.env.VUE_APP_SCHEDULE_API
  })
}

// 根据作品ID获取作品类型
export function getAuthorWorksTypeByWorkIdnew (data) {
  return request({
    url: '/api/AuthorWorksType/GetAuthorWorksTypeByWorkIdnew',
    method: 'post',
    data
  })
}
